module.exports = __webpack_public_path__ + "fonts/montserrat-latin-800.db9a3e0.woff2";